import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    background: 'yellow',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  textarea: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    border: 'none',
    outline: 'none !important',
    fontSize: theme.typography.htmlFontSize,
    fontFamily: theme.typography.fontFamily,
    padding: '1.5em 2.5em',
  },
  '@media(max-width: 500px)': {
    textarea: {
      padding: '1em 1.5em 5px',
    },
  },
}));

function stripTags(html) {
  if (!html) return '';
  const div = document.createElement("div");
  div.innerHTML = html.replace('><', '> <').replace('  ', ' ');
  return div.textContent || div.innerText || "";
}

function getText(content) {
  let note = content;
  try {
    const parsed = JSON.parse(content);

    note = '';
    const len = parsed.blocks.length;
    let i = 0;
    while(i < len) {
      note += parsed.blocks[i].text + '\n';
      i++;
    }
  } catch (e) {}
  return stripTags(note)
}

function SimpleEditor(props) {
  const classes = useStyles();
  const { content, setContent } = props;


  useEffect(() => {
    setContent(getText(props.note.content));
    // eslint-disable-next-line
  }, []);

  return(
    <div className={classes.wrapper}>
      <textarea
        className={classes.textarea}
        value={content}
        onChange={ev => {setContent(ev.target.value); props.action()}}
        onClick={props.action}
        onMouseMove={props.action}
      ></textarea>
    </div>
  )
}

export default SimpleEditor;